import { render } from "./Language.html?vue&type=template&id=6a0f3b2c&scoped=true&ts=true&external"
import script from "./Language.ts?vue&type=script&lang=ts&external"
export * from "./Language.ts?vue&type=script&lang=ts&external"

import "./Language.css?vue&type=style&index=0&id=6a0f3b2c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0f3b2c"]])

export default __exports__